import {JSX} from "lib/commons/xml/dom";
import {IReg, REG} from "lib/commons/registry";
import {ITEM} from "lib/wsp/item";
import {BaseElement, MsgLabel, OMsgLabelInit, OSkinableInit} from "back/commons/basis";
import {IItemUiEnv} from "back/wsp/views/itemMain";
import {InputUserPanel, OInputUserInit} from "back/core/widgets/inputs";
import {RESPS, SRC} from "lib/wsp/src";
import {IDatasResp} from "lib/wsp/wspMetaUi";
import {EUserType} from "lib/core/user";
import {DOMSH} from "lib/commons/xml/domsh";
import {ERROR} from "lib/core/errorReport";
import "back/wsp/actions/actions_Perms";

export interface ORespEditFieldInit extends OSkinableInit {
	resp: string,
	confInput?: OInputUserInit<any>,
}

/**
 * Edition d'une resp sur un item donné
 */
export class RespEditField extends BaseElement {

	reg: IReg<IItemUiEnv>;

	private _inputSingleUser: InputUserPanel<any>;

	/** Objet resp édité */
	get resp(): IDatasResp | null {
		return this._resp;
	}

	private _resp: IDatasResp;

	protected _initialize(init: ORespEditFieldInit) {
		this.reg = this.findReg(init);
		const longDesc = this.reg.env.longDesc;
		const itemType = this.reg.env.wsp.wspMetaUi.getItemType(longDesc.itModel);
		this._resp = itemType.getResp(init.resp);
		if (this.resp) {
			this._inputSingleUser = <InputUserPanel class="values" î={Object.assign({
				reg: this.reg,
				userCard: this.resp.userCard,
				required: this.resp.required,
				selectWithConfirm: true,
				usersGridInit: {
					usersSrv: init.reg.env.universe.useUsers,
					filterGroups: this.resp.usersSelection.restrictFromGroups,
					filterType: this.resp.usersSelection.userType === 'groups' ? EUserType.group : (this.resp.usersSelection.userType === 'users' ? EUserType.user : null),
				}
			} as OInputUserInit<any>, init.confInput)}/> as InputUserPanel<any>;
			this._update();
			this._inputSingleUser.addEventListener('change', this.onChange);
		}
		this._attach(this.localName, init, this._inputSingleUser || <MsgLabel class="more" î={{label: "Responsabilité inconnue", level: "error"} as OMsgLabelInit}/>);
	}

	async onChange(this: InputUserPanel<any>, ev: FocusEvent) {
		const me = DOMSH.findHost(this) as RespEditField;
		try {
			if (me.isWritable()) {
				const longDesc = me.reg.env.longDesc;
				const rspUsrs = RESPS.toRespsList(longDesc.rspUsrs);
				const iniValue = rspUsrs[me.resp.code] || [];
				if (me.resp.userCard === 'single') {
					if (this.value && this.value[0])
						await ITEM.fetchUpdateRespByRespSingle(me.reg.env.wsp, me, [SRC.srcRef(me.reg.env.longDesc)], me.resp.code, this.value[0]);
					else
						await ITEM.fetchUpdateRespByRespMulti(me.reg.env.wsp, me, [SRC.srcRef(me.reg.env.longDesc)], me.resp.code, null, iniValue);
				} else if (me.resp.userCard === 'multi') {
					const newValue = this.value || [];

					const adds: string[] = [];
					const removes: string[] = [];
					newValue.forEach((resp) => {
						if (iniValue.indexOf(resp) == -1) adds.push(resp)
					});
					iniValue.forEach((resp) => {
						if (newValue.indexOf(resp) == -1) removes.push(resp)
					});
					await ITEM.fetchUpdateRespByRespMulti(me.reg.env.wsp, me, [SRC.srcRef(me.reg.env.longDesc)], me.resp.code, adds, removes);
				}
			}
		} catch (e) {
			const resp = me.resp.name;
			await ERROR.report(`Échec lors de la mise à jour de la responsabilité '${resp}'`, e);
		}
	}

	/** Retourne true si cette resp peut être éditée */
	private isWritable(): boolean {
		// FIXME : évaluer une perm dédiée à la resp
		return this.reg.hasPerm("action.item#set.resps");
	}

	/** Réintialise le composant en fonction des propriétés courantes de l'item */
	private _update() {
		const longDesc = this.reg.env.longDesc;
		const rspUsrs = RESPS.toRespsList(longDesc.rspUsrs);
		this._inputSingleUser.value = rspUsrs[this.resp.code] || [];
		this._inputSingleUser.disabled = !this.isWritable();
	}
}

customElements.define("resp-field-edit", RespEditField);

REG.reg.registerSkin('resp-field-edit', 1, /* language=CSS */ `
	c-input-users-panel:invalid {
		border-color: var(--error-color);
	}

	c-input-users-panel {
		border: 1px solid transparent;
	}

`);


